import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import {
  DetailColumn,
  DetailField,
  DetailFieldSection,
  DetailAdditionalSection,
} from "@/components/details";
import { contestAgreementDetail } from "@/schemas/contestAgreement";
import { useContestAgreementData } from "../hooks/useContestAgreementData";
import { useContestAgreementId } from "../hooks/useContestAgreementId";
import { Module, PATH_CONTRACTOR } from "@/constants";
import { EntityListLink } from "@/components/EntityListLink";
import { useContestAgreementsFieldPermissions } from "../hooks/useContestAgreementsFieldPermissions";

export const ContestAgreementDetails = () => {
  const { t } = useTranslation();
  const id = useContestAgreementId();
  const contestAgreement = useContestAgreementData(id);
  const { canSeePresentationImageCount } =
    useContestAgreementsFieldPermissions();

  return (
    <>
      <CollapsibleSection title={t("contestAgreements.detail.basicDataHeader")}>
        <DetailFieldSection
          module={Module.ContestAgreements}
          schema={contestAgreementDetail}
          data={contestAgreement}
        >
          <DetailColumn>
            <DetailField field="contractor_user_ref_number" />
            <DetailField field="contractor_full_name" />
            <DetailField field="period" />
            <DetailField
              field="agreement2_presentation_image_count"
              isVisible={canSeePresentationImageCount}
            />
          </DetailColumn>
          <DetailColumn>
            <DetailField field="agreement_company_name" />
            <DetailField field="agreement_start_date" />
            <DetailField field="agreement2_sent_at" />
            <DetailField field="agreement2_sign_date" />
            <DetailField field="payroll_version" />
          </DetailColumn>
        </DetailFieldSection>

        <Separator className="my-4" />

        <DetailAdditionalSection
          title={t("contractors.details.title")}
          headerAction={
            <EntityListLink
              path={generatePath(PATH_CONTRACTOR, {
                contractorId: contestAgreement.contractor_id,
              })}
              className="h-7 w-7 shrink-0"
            />
          }
        >
          <DetailFieldSection
            module={Module.Contractors}
            schema={contestAgreementDetail}
            data={contestAgreement}
          >
            <DetailColumn>
              <DetailField field="contractor_email" />
            </DetailColumn>
            <DetailColumn>
              <DetailField field="contractor_phone_number" />
            </DetailColumn>
          </DetailFieldSection>
        </DetailAdditionalSection>
      </CollapsibleSection>
    </>
  );
};
